import { castArray } from 'lodash'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

const useTagIds = () => {
  const { query: { tags } = {} } = useRouter()
  return useMemo(() => castArray(tags || []), [tags])
}

export { useTagIds }
